module.exports = __webpack_public_path__ + "static/media/hmong.a4e3b886.svg";